import React from 'react'

// Material-UI
import {
    Box,
    CircularProgress,
    ThemeProvider,
} from '@material-ui/core'

// Theme
import Theme from 'common/layout/themes/mainTheme'

// Styles
import styles from './app.module.scss'

function Index() {
    return (
        <ThemeProvider theme={Theme}>
            <Box className={styles['outer-wrapper']}>
                <div>
                    <CircularProgress
                        size="50px"
                    />
                </div>
            </Box>
        </ThemeProvider>
    )
}

export default Index

